import { Mail, Clock } from "lucide-react";

export default function MailSend() {
  return (
    <div className="space-y-5">
      {/* Başlık */}
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gray-900 text-white">
          <Mail className="w-5 h-5" />
        </span>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Mail Gönder</h1>
          <p className="text-sm text-gray-500">Bağımsız e-posta oluştur ve gönder</p>
        </div>
      </div>

      {/* Pasif durum */}
      <div className="flex flex-col items-center justify-center rounded-2xl border-2 border-dashed border-gray-200 bg-gray-50 py-32 gap-4 text-gray-400">
        <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-gray-100">
          <Clock className="w-8 h-8 text-gray-400" />
        </span>
        <div className="text-center space-y-1">
          <p className="text-base font-semibold text-gray-600">Yakında Kullanılabilir</p>
          <p className="text-sm text-gray-400">Bu özellik henüz aktif değil, backend entegrasyonu tamamlandığında açılacak.</p>
        </div>
      </div>
    </div>
  );
}
